import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { CsatSubmissionTranscriptComponent } from './types';
import { ResponseMessage } from 'src/pages/solve-config/styledComponents';
import {
  selectLegibleTextColor,
  selectWidgetConfiguration,
} from 'src/slices/solve-config/solveConfigSlice';

export const CsatSubmissionStep = ({
  transcriptComponent,
}: {
  transcriptComponent: CsatSubmissionTranscriptComponent;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { theme_color: themeColor } = useSelector(selectWidgetConfiguration);

  return (
    <ResponseMessage backgroundColor={themeColor}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <CsatField
          name={t('csatSubmissionStep.csatScore')}
          value={transcriptComponent.csat_score}
        />

        <CsatField
          name={t('csatSubmissionStep.reasonsForRating')}
          value={
            transcriptComponent.csat_feedback &&
            transcriptComponent.csat_feedback.length > 0
              ? transcriptComponent.csat_feedback.join(',')
              : undefined
          }
        />

        <CsatField
          name={t('csatSubmissionStep.additionalFeedback')}
          value={transcriptComponent.additional_feedback}
        />

        <CsatField
          name={t('csatSubmissionStep.resolutionConfirmation')}
          value={transcriptComponent.csat_resolve}
        />
      </Box>
    </ResponseMessage>
  );
};

const CsatField = ({
  name,
  value,
}: {
  name: string;
  value?: string | boolean;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const fontColor = useSelector(selectLegibleTextColor);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography color={fontColor} variant='font16'>
        {t('common.labelWithColon', { label: name })}
      </Typography>
      <Typography color={fontColor} variant='font16'>
        {value || t('csatSubmissionStep.fallbackValue')}
      </Typography>
    </Box>
  );
};
